import { Button } from '../../../components-v2/Button';
import {
	Dialog,
	DialogDescription,
	DialogFooter,
	DialogHeader,
	DialogPopup,
	DialogTitle,
} from '../../../components-v2/Dialog';

interface IProps {
	canSave: boolean;
	isSaving?: boolean;
	open: boolean;
	onCloseWithoutSaving(): void;
	onKeepEditing(): void;
	onSaveAndClose(): void;
}

export function UnsavedChangesDialog({
	canSave,
	isSaving = false,
	open,
	onCloseWithoutSaving,
	onKeepEditing,
	onSaveAndClose,
}: IProps) {
	return (
		<Dialog
			open={open}
			onOpenChange={nextOpen => {
				if (!nextOpen && !isSaving) {
					onKeepEditing();
				}
			}}
			dismissOnOutsideClick={!isSaving}
		>
			<DialogPopup showCloseButton={!isSaving}>
				<DialogHeader>
					<DialogTitle>You have unsaved changes</DialogTitle>
					<DialogDescription>
						{canSave
							? 'Save your changes before closing, or close without saving to discard them.'
							: 'Closing now will discard the changes you made to this message.'}
					</DialogDescription>
				</DialogHeader>
				<DialogFooter>
					<Button variant='secondary' onClick={onKeepEditing} disabled={isSaving}>
						Keep editing
					</Button>
					<Button variant='destructive-secondary' onClick={onCloseWithoutSaving} disabled={isSaving}>
						Close without saving
					</Button>
					{canSave ? (
						<Button onClick={onSaveAndClose} isLoading={isSaving}>
							Save &amp; close
						</Button>
					) : null}
				</DialogFooter>
			</DialogPopup>
		</Dialog>
	);
}
